<template>
  <nuxt-link
    :key="tag._id"
    :to="localePath({ name: 'articleTag-slug', params: { slug: tag.page_meta.slug }})"
    class="ArticleTagListTag">
    {{ tag.title }}
  </nuxt-link>
</template>

<script>
export default {
  props: {
    tag: Object,
  },
}
</script>

<style lang="scss">
@import '~variables';

.ArticleTagListTag {
  display: inline-block;
  padding: 0.25rem 1rem;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
  font-size: $font-size-sm;
  white-space: nowrap;
  color: #fff;
  background-color: $gray-500;

  &:hover {
    color: #fff;
    background-color: $gray-400;
  }
}
</style>
